import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';


export default function InfoIcon(props) {
    const { ...rest } = props;
    return (
        <SvgIcon {...props} viewBox="0 0 16 16" {...rest}>
            <title>Info_Icon</title>
            <path d="M8,2.4A5.6,5.6,0,1,1,2.4,8,5.6,5.6,0,0,1,8,2.4M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm.8,12.05H7.2V6.48H8.8ZM8,3.61A1,1,0,1,0,9,4.56.95.95,0,0,0,8,3.61Z" />
        </SvgIcon >
    );
}